import React, { useEffect } from 'react';
import { APP_PATH } from 'config';
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import MenuPhub from 'components/MenuPhub';
import { getLayoutLinkString } from 'consts';
import { EnumAppRouter, EnumLayoutRouter } from 'router/enum';
import LAYOUT_ROUTER from 'router/layoutRouter';
import StatusEnum from 'axios/enum';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { useDispatch } from 'react-redux';
import { userInfoAction, IuserInfo } from 'reducer/common/userInfo';
import BreadCrumb from './components/BreadCrumb';
import Header from './components/Header';
import CustomerService from './components/CustomerService';

const PageBreadCrumb = () => {
  const pathname = useLocation().pathname.toLowerCase();

  const breadCrumbData = [
    {
      url: EnumLayoutRouter.訂單下載,
      textList: ['首頁', '訂單下載'],
    },
    {
      url: EnumLayoutRouter.驗收單下載,
      textList: ['首頁', '驗收單下載'],
    },
    {
      url: EnumLayoutRouter.退貨單下載,
      textList: ['首頁', '退貨單下載'],
    },
  ];
  return (
    <>
      {breadCrumbData.map((v) => {
        if (pathname === getLayoutLinkString(v.url)) {
          return (
            <BreadCrumb
              key={v.url}
              data={v.textList.map((text, idx) => ({
                children: text,
                active: true,
                style: idx === v.textList.length - 1 ? {} : { color: 'black' },
              }))}
            />
          );
        }
        return undefined;
      })}
    </>
  );
};

const Layout = () => {
  const { setUserInfoRedux } = userInfoAction;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axios = useAxios();
  const getUserInfo = async () => {
    const response = await axios.doAxios<unknown, { userInfo: IuserInfo }>(
      MethodEnum.post,
      'user/queryUserInfo',
    );
    if (response && response.data.status === StatusEnum.完成) {
      // 新增判斷 如果回傳的 retailerIds 為空陣列，跳到錯誤頁
      if (response.data.data.userInfo.retailerIds.length <= 0) {
        navigate(EnumAppRouter.錯誤頁);
        return;
      }
      dispatch(setUserInfoRedux(response.data.data.userInfo));
    }
  };
  useEffect(() => {
    getUserInfo();
  }, []);

  return (
    <>
      <MenuPhub />
      <div className="content-page">
        <div className="content">
          {/* 上方選單 */}
          <Header />
          <div className="container-fluid">
            <PageBreadCrumb />

            <Routes>
              {LAYOUT_ROUTER.map((v) => (
                <Route key={v.url} path={v.url} element={v.component} />
              ))}
              <Route
                path="/*"
                element={<Navigate to={APP_PATH + EnumLayoutRouter.首頁} />}
              />
            </Routes>
          </div>
          <CustomerService />
        </div>
      </div>
    </>
  );
};
export default Layout;
